export enum DownloadFileType {
    CSV = 'CSV',
    GEOJSON = 'GEOJSON',
    XLSX = 'XLSX',
    XLS = 'XLS',
    SHAPEFILE = 'SHAPEFILE',
    PDF = 'PDF'
}
